<template>
    <GeoFence :formType="true" />
</template>
<script>
import GeoFence from '@/components/fence/geofence'
export default {
    components: {
        GeoFence
    }
}
</script>